import React, { forwardRef, useRef } from "react";
import PlacesAutocomplete from "react-places-autocomplete";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { Loader } from "../loaders";
import { FindLoad } from "utils";

const getNestedError = (obj, path) => {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
};

export const AddressInputMain = forwardRef(
  (
    {
      name,
      rules,
      control,
      label,
      placeholder,
      labelHeader,
      type = "text",
      customDesign = true,
      className,
      onSelect,
      endIcon,
      loadType,
      ...anotherProps
    },
    ref,
  ) => {
    const loader = FindLoad(loadType);
    const inputRef = useRef(null);

    return (
      <div
        style={{ position: "relative" }}
        className={`input-main-wrapper ${
          customDesign ? "input-custom-wrapper" : ""
        } ${className ? className : ""}`}
        ref={inputRef}
      >
        <Controller
          ref={ref}
          control={control}
          name={name}
          rules={rules}
          render={({ field, formState: { errors } }) => {
            const error = getNestedError(errors, name);
            const hasError = !!error?.type;

            if (hasError && inputRef.current) {
              inputRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }

            return (
              <PlacesAutocomplete
                value={field?.value}
                onChange={field?.onChange}
                onSelect={onSelect || field.onChange}
                ref={ref}
              >
                {({
                  getInputProps,
                  suggestions,
                  getSuggestionItemProps,
                  loading,
                }) => (
                  <>
                    {labelHeader && (
                      <p
                        className={`input-main-label-header ${
                          errors[field?.name]?.message ? "errorLabel" : ""
                        }`}
                      >
                        {labelHeader}
                        {rules?.required && (
                          <span className="input-main-label-header-required">
                            *
                          </span>
                        )}
                      </p>
                    )}

                    <TextField
                      ref={ref}
                      {...anotherProps}
                      {...field}
                      {...getInputProps()}
                      error={hasError}
                      autoComplete="off"
                      type={type}
                      value={field.value}
                      placeholder={placeholder}
                      label={label}
                      InputProps={
                        !!loader?.length || endIcon
                          ? {
                              ...getInputProps()?.InputProps,
                              endAdornment: !!loader?.length && (
                                <Loader
                                  styles={{
                                    position: "absolute",
                                    right: 10,
                                    width: 15,
                                    height: 15,
                                  }}
                                />
                              ),
                            }
                          : { ...getInputProps()?.InputProps }
                      }
                    />
                    <p className="error-message">
                      <p className="error-message">{error?.message}</p>
                    </p>

                    <div className="address-suggestion-custom-input-wrapper">
                      {loading && (
                        <div className="address-loading-class">Loading...</div>
                      )}

                      <div className="address-custom-input-suggestions">
                        {suggestions.map((suggestion, index) => {
                          const className = "suggestion-item";
                          return (
                            <p
                              key={index}
                              {...getSuggestionItemProps(suggestion, {
                                className,
                              })}
                            >
                              {suggestion.description}
                            </p>
                          );
                        })}
                      </div>
                    </div>
                  </>
                )}
              </PlacesAutocomplete>
            );
          }}
        />
      </div>
    );
  },
);

AddressInputMain.displayName = "AddressInputMain";
